module.exports = __webpack_public_path__ + "img/in-progress.c928e108.svg";